import React from "react";

type ButtonProps = React.ComponentPropsWithoutRef<"button"> &
  Partial<{
    secondary: boolean;
  }>;
const Button: React.FC<ButtonProps> = (props) => {
  const { children, secondary, onClick } = props;
  return (
    <React.Fragment>
      <button
        className={`button ${
          secondary ? "button-secondary" : "button-primary"
        }`}
        onClick={onClick}
      >
        {children}
      </button>
      <style jsx>{`
        .button {
          width: fit-content;
          padding: 8px 24px;
          border: solid 1px var(--color-red);
          border-radius: 30px;
          font-weight: 500;
        }
        .button-primary {
          background-color: var(--color-red);
          color: var(--color-white);
        }
        .button-secondary {
          background-color: transparent;
          color: var(--color-red);
        }
        .button-primary:hover {
          color: var(--color-white);
        }
      `}</style>
    </React.Fragment>
  );
};

export default Button;
